import { render, staticRenderFns } from "./ApplicationsTable.vue?vue&type=template&id=4cf2afd4&"
import script from "./ApplicationsTable.vue?vue&type=script&lang=js&"
export * from "./ApplicationsTable.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsTable.vue?vue&type=style&index=0&id=4cf2afd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports